import { action } from 'satcheljs';

export const clearAllFullCalendarEvents = action(
    'CALENDAR_EVENTS_CLEAR_ALL_FULL_CALENDAR_EVENTS',
    () => ({})
);
